/**
 *	common.js
 */
'use strict';
// import $ from 'jquery'; // webpackから読み込む時

/* config
--------------------------------------------------*/
var app = app || {};
var data = data || {};  // グローバル変数格納用
data.spBreakPoint = 750;

// グローバル変数設定
data.ww = window.innerWidth ? window.innerWidth: $(window).width();
data.wh = window.innerHeight ? window.innerHeight: $(window).height();
data.cww = data.ww;  // リサイズ前のウインドウ幅を保持
data.cwh = data.wh;  // リサイズ前のウインドウ高を保持
data.scrollTop = $(window).scrollTop();
data.scrollBottom = data.scrollTop + data.wh;
data.isSP = (data.ww <= data.spBreakPoint) ? true : false;

var userAgent = window.navigator.userAgent.toLowerCase();
var _ua = (function(u){
  return {
    Tablet:(u.indexOf("windows") != -1 && u.indexOf("touch") != -1 && u.indexOf("tablet pc") == -1) 
      || u.indexOf("ipad") != -1
      || (u.indexOf("android") != -1 && u.indexOf("mobile") == -1)
      || (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1)
      || u.indexOf("kindle") != -1
      || u.indexOf("silk") != -1
      || u.indexOf("playbook") != -1,
    Mobile:(u.indexOf("windows") != -1 && u.indexOf("phone") != -1)
      || u.indexOf("iphone") != -1
      || u.indexOf("ipod") != -1
      || (u.indexOf("android") != -1 && u.indexOf("mobile") != -1)
      || (u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1)
      || u.indexOf("blackberry") != -1,
    iOS: u.indexOf("iphone") > 0
      || u.indexOf("ipod") > 0
  }
})(userAgent);

if (_ua.Tablet) {
  $('body').addClass('tablet');
} else if (_ua.Mobile) {
  $('body').addClass('mobile');
  data.isSP = true;
}
if (_ua.iOS) {
  $('body').addClass('ios');
}
if (userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) {
  $('body').addClass('ie');
} else if(userAgent.indexOf('edge') != -1) {
  $('body').addClass('edge');
}

/* LOADED
--------------------------------------------------*/
$(window).on('load', function() {
  $('.loading').fadeOut(function() {
    $(this).remove();
  });
});

/* READY
--------------------------------------------------*/
$(function() {
  // # で始まるリンクにスムーススクロール
  data.scSpeed = 600;
  function scrollHdl(_href) {
    var target = $(_href == "#" || _href == "" ? 'html' : _href);
    var position = target.offset().top;
    if (!data.isSP) {
      position -= 60;
    } else {
      // position += 10;
      $('html').removeClass('is-block');
    }
    $('body,html').animate({scrollTop:position}, data.scSpeed, 'swing');
  }
  $('a[href^="#"].js-ancher').on('click', function (e) {
    e.preventDefault();
    var href= $(this).attr("href");
    if(href=="#") return false;
    if(href=="#pagetop"){
     $("html, body").animate({scrollTop: 0}, data.scSpeed, 'swing');
     return false;
    }
    scrollHdl(href);
    return false;
  });
  // 遷移後のページ内リンク
  data.URLhash = location.hash;
  if (data.URLhash !== '') {
    setTimeout(function() {
      if (data.URLhash) scrollHdl(data.URLhash);
    }, 300);
  }
  
  $('.sp-navbtn').on('click', function (e) {
    e.preventDefault();
    if ($('html').hasClass('is-block')) {
      $('html').removeClass('is-block');
    } else {
      $('html').addClass('is-block');
    }
    return false;
  });

  $('.btn-popup').modaal();
  $('.btn-popup').on('click', function() {
    $('html').removeClass('is-block');
  })

  heightArrChange();
  
});

/* FUCTION
--------------------------------------------------*/
function heightArrChange() {
  if (data.isSP) {
    heightArrange.off($('.js-ha1'));
    heightArrange.off($('.js-ha2'));
    heightArrange.off($('.js-ha3'));
    heightArrange.off($('.js-ha4'));
    heightArrange.off($('.js-ha5'));
    heightArrange.off($('.js-ha6'));
  } else {
    heightArrange.on($('.js-ha1'));
    heightArrange.on($('.js-ha2'));
    heightArrange.on($('.js-ha3'));
    heightArrange.on($('.js-ha4'));
    heightArrange.on($('.js-ha5'));
    heightArrange.on($('.js-ha6'));
  }
}

$(window).on("orientationchange",function(){
  location.reload();
});

/* RESIZE
--------------------------------------------------*/
data.resizeFlag = false;
$(window).on('resize orientationchange', function() {
  data.ww = window.innerWidth ? window.innerWidth: $(window).width();
  data.wh = window.innerHeight ? window.innerHeight: $(window).height();
  data.scrollTop = $(window).scrollTop();
  data.scrollBottom = data.scrollTop + data.wh;
  if(!data.resizeFlag) {
    data.resizeFlag = true;
    setTimeout(function(){
      if(data.ww <= data.spBreakPoint) {
        data.isSP = true;
        if(data.cww != data.ww){
          data.cww = data.ww;
          // isSP

        }
      }else {
        data.isSP = false;
        data.cww = data.ww;
        // isPC
        if (data.key != "view_pc") {

        }
      }
      if (_ua.iOS && data.cwh != data.wh) {
        if (data.cwh < data.wh) {
          $('body').removeClass('is-menu');
        } else {
          $('body').addClass('is-menu');
        }
        data.cwh = data.wh;
      }

      heightArrChange();

      data.resizeFlag = false;
      return data.resizeFlag;
    },100);
  }
}).trigger('resize');

/* SCROLL
--------------------------------------------------*/
data.vHeight = 700;
$(window).on('scroll',function(){
  data.scrollTop = $(window).scrollTop();

  var _target = $('#nav');
  var p = _target.offset().top;
  var n = Math.min(1, data.scrollTop / p);
  if(n == 1 && !data.isSP) {
    $('#nav').addClass('fixed');
  } else {
    $('#nav').removeClass('fixed');
  }
  data.pagetopPoint = 0;
  if (data.isSP) {
    data.pagetopPoint = $('#footer').offset().top - 0;
  } else {
    data.pagetopPoint = $('#footer').offset().top - 70;
  }
  if ((data.scrollTop + data.wh) > data.pagetopPoint) {
    $('#pagetop').addClass('is-static');
  } else {
    $('#pagetop').removeClass('is-static');
  }
  if (data.scrollTop < 10) {
    $('#pagetop').fadeOut();
  } else {
    $('#pagetop').fadeIn();
  }
}).trigger('scroll');

var heightArrange = {
  on: function(target){
    target.css('height', 'auto');
    var setH = 0;
    $.each(target, function(index, val) {
      setH = Math.max(setH,$(this).height());
    });
    target.height(setH);
  },
  off: function(target) {
    target.css('height', 'auto');
  }
};